import React, { useState, useEffect } from "react";
import api from "../../../api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
// import { fetchEmployee } from "./store/employeeSlice";
import { useDispatch } from "react-redux";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";

const EmployeeData = () => {
  const [activeTab, setActiveTab] = useState("employeeinfo");
  const [isLoading, setIsLoading] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeData, setEmployeeData] = useState({
    sn: "",
    uan: "",
    pf_no: "",
    employee_code: "",
    first_name: "",
    last_name: "",
    gender: "",
    date_of_joining: "",
    date_of_birth: "",
    father_husband: "",
    aadhaar_no: "",
    email: "",
    phone: "",
    pan_no: "",
    employee_components: [
      {
        employee_component_id: "",
        component_name: "",
        component_value: "",
        is_calculated: 0,
      },
    ],
    bank_details: {
      bank_name: "",
      branch: "",
      account_number: "",
      ifsc_code: "",
      bank_account_holder_name: "",
      swift_code: "",
    },
    attendance: {
      name: "",
      present_day: "",
      absent_day: "",
      paid_holiday: "",
      leave_addition_pl: "",
      leave_addition_cl: "",
      balance_leave: "",
      working_days_applicable: "",
    },
  });
  const [isEmployee, setIsEmployee] = useState(false);
  const dispatch = useDispatch();

  const tabOrder = ["employeeinfo", "bankdetails"];

  useEffect(() => {
    const userType = localStorage.getItem("type");
    const id = localStorage.getItem("userId");
    if (userType === "Employee") {
      setIsEmployee(true);
    }
    if (id) {
      setEmployeeId(id);
    }
    // The backend resolves the employee from the auth token, so "My Data" works
    // for every role (not just Employee) as long as the user is linked to an
    // employee record.
    fetchEmployeeData(id);
  }, []);

  const fetchEmployeeData = async (id) => {
    try {
      const response = await api.post(`/single-employee-details`);
      if (response.data.status === 200) {
        const data = response.data.data[0] || {};
        const ensureZeroOrValue = (value) => (value === 0 ? "0" : value || "");

        setEmployeeData({
          sn: ensureZeroOrValue(data.sn),
          uan: ensureZeroOrValue(data.uan),
          pf_no: ensureZeroOrValue(data.pf_no),
          employee_code: ensureZeroOrValue(data.employee_code),
          first_name: ensureZeroOrValue(data.first_name),
          last_name: ensureZeroOrValue(data.last_name),
          gender: ensureZeroOrValue(data.gender),
          date_of_joining: ensureZeroOrValue(data.date_of_joining),
          date_of_birth: ensureZeroOrValue(data.date_of_birth),
          father_husband: ensureZeroOrValue(data.father_husband),
          aadhaar_no: ensureZeroOrValue(data.aadhaar_no),
          email: ensureZeroOrValue(data.email),
          phone: ensureZeroOrValue(data.phone),
          pan_no: ensureZeroOrValue(data.pan_no),
          employee_components: data.employee_components?.map((comp) => ({
            employee_component_id: ensureZeroOrValue(comp.components_id),
            component_name: ensureZeroOrValue(comp.components?.component_name),
            component_value: ensureZeroOrValue(comp.value),
            is_calculated: comp.is_calculated || 0,
          })) || [
            {
              employee_component_id: "",
              component_name: "",
              component_value: "",
              is_calculated: 0,
            },
          ],
          bank_details: {
            bank_name: data.bank_details?.bank_name || "",
            branch: data.bank_details?.branch || "",
            account_number: data.bank_details?.account_number || "",
            ifsc_code: data.bank_details?.ifsc_code || "",
            bank_account_holder_name:
              data.bank_details?.bank_account_holder_name || "",
            swift_code: data.bank_details?.swift_code || "",
          },
          attendance: {
            name: ensureZeroOrValue(data.attendance?.[0]?.name),
            present_day: ensureZeroOrValue(data.attendance?.[0]?.present_day),
            absent_day: ensureZeroOrValue(data.attendance?.[0]?.absent_day),
            paid_holiday: ensureZeroOrValue(data.attendance?.[0]?.paid_holiday),
            leave_addition_pl: ensureZeroOrValue(
              data.attendance?.[0]?.leave_addition_pl
            ),
            leave_addition_cl: ensureZeroOrValue(
              data.attendance?.[0]?.leave_addition_cl
            ),
            balance_leave: ensureZeroOrValue(
              data.attendance?.[0]?.balance_leave
            ),
            working_days_applicable: ensureZeroOrValue(
              data.attendance?.[0]?.working_days_applicable
            ),
          },
        });
      } else {
        console.error("Failed to fetch employee data:", response.data.message);
      }
    } catch (error) {
      console.error("An error occurred while fetching employee data:", error);
    }
  };

  const handleInputChange = (e, section, field, index = null) => {
    if (isEmployee) return;

    if (section === "employee_components" && index !== null) {
      const updatedComponents = [...employeeData.employee_components];
      updatedComponents[index][field] = e.target.value;
      setEmployeeData({
        ...employeeData,
        employee_components: updatedComponents,
      });
    } else {
      setEmployeeData((prevState) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [field]: e.target.value,
        },
      }));
    }
  };

  const handleSaveAndNext = () => {
    if (isEmployee) return;
    const currentIndex = tabOrder.indexOf(activeTab);
    const nextIndex = (currentIndex + 1) % tabOrder.length;
    setActiveTab(tabOrder[nextIndex]);
  };

  const handleSaveAndClose = async () => {
    if (isEmployee) return;
    setIsLoading(true);
    try {
      const response = await api.post(`/update-employee/${employeeId}`, {
        ...employeeData,
      });
      if (response.data.status === 200) {
        toast.success(response.data.message);
        // dispatch(fetchEmployee());
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Header />
      <Sidebar />
      <div style={{ padding: "20px" }}>
        <h3>My Profile</h3>
        <ul
          style={{
            display: "flex",
            listStyle: "none",
            padding: 0,
            marginBottom: "20px",
            borderBottom: "1px solid #ddd",
          }}
        >
          {[
            { label: "Employee Info", key: "employeeinfo" },
            { label: "Bank Details", key: "bankdetails" },
          ].map((tab) => (
            <li
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                cursor: "pointer",
                padding: "10px 15px",
                borderBottom:
                  activeTab === tab.key ? "2px solid #ff9b44" : "none",
                fontWeight: activeTab === tab.key ? "bold" : "normal",
                color: activeTab === tab.key ? "#ff9b44" : "#333",
              }}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        {activeTab === "employeeinfo" && (
          <div>
            <form>
              <div className="row">
                {[
                  "sn",
                  "uan",
                  "pf_no",
                  "employee_code",
                  "first_name",
                  "last_name",
                  "gender",
                  "date_of_joining",
                  "date_of_birth",
                  "father_husband",
                  "aadhaar_no",
                  "email",
                  "phone",
                  "pan_no",
                ].map((field) => (
                  <div className="col-lg-3 mb-3" key={field}>
                    <label>{field.replace(/_/g, " ").toUpperCase()}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={employeeData[field] || ""}
                      onChange={(e) =>
                        handleInputChange(e, "employeeinfo", field)
                      }
                      disabled // My Data is a read-only self-view for all roles
                    />
                  </div>
                ))}
              </div>
            </form>
          </div>
        )}

        {activeTab === "bankdetails" && (
          <div>
            <form>
              <div className="row">
                {[
                  { label: "Bank Name", field: "bank_name" },
                  { label: "Branch", field: "branch" },
                  { label: "Account Number", field: "account_number" },
                  { label: "IFSC Code", field: "ifsc_code" },
                  {
                    label: "Account Holder Name",
                    field: "bank_account_holder_name",
                  },
                  { label: "SWIFT Code", field: "swift_code" },
                ].map((item) => (
                  <div
                    className="col-lg-4 mb-3"
                    key={item.field}
                    style={{ marginBottom: "15px", paddingRight: "15px" }}
                  >
                    <label style={{ display: "block", marginBottom: "5px" }}>
                      {item.label}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={employeeData.bank_details?.[item.field] || ""}
                      onChange={(e) =>
                        handleInputChange(e, "bank_details", item.field)
                      }
                      disabled
                    />
                  </div>
                ))}
              </div>
            </form>
          </div>
        )}

        {/* <div className="mt-4">
        {!isEmployee && (
          <>
            <button
              type="button"
              onClick={handleSaveAndNext}
              className="btn btn-warning me-2"
            >
              Save and Next
            </button>
            <button
              type="button"
              onClick={handleSaveAndClose}
              className="btn btn-success"
              disabled={isLoading}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : "Save and Close"}
            </button>
          </>
        )}
      </div> */}
      </div>
    </div>
  );
};

export default EmployeeData;
